/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import axios from "axios";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import firebase from "./firebase";

import ProtectedRoute from "./components/ProtectedRoute";
import LogIn from "./components/LogIn";
import InputView from "./components/InputView";
import CabinetView from "./components/CabinetView";

const App = () => {
  const [user, setUser] = useState<any | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleWake = async () => {
    try {
      const res = await axios.get(
        "https://us-central1-thought-cabinet.cloudfunctions.net/app/wakeUp"
      );
    } catch (error) {
      console.error("Error", error);
    }
  };

  const handleLogin = async (
    e: { preventDefault: () => void },
    email: string,
    password: string
  ) => {
    e.preventDefault();

    await firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((userCredential) => {
        setUser(userCredential.user);
        setIsAuthenticated(true);
      })
      .catch((error) => {
        const errorCode = error.code;
      });
  };

  useEffect(() => {
    let unsubscribe: (() => void) | undefined;
    handleWake();

    // const userStr = localStorage.getItem("user");
    const savedUser = null;

    if (savedUser) {
      setUser(savedUser);
      setIsAuthenticated(true);
    } else {
      unsubscribe = firebase.auth().onAuthStateChanged((currentUser) => {
        setUser(currentUser);
        if (currentUser) {
          setIsAuthenticated(true);
          // localStorage.setItem("user", JSON.stringify(currentUser));
        }
      });
    }
    return () => unsubscribe && unsubscribe();
  }, []);

  return (
    <Router>
      <Routes>
        <Route
          path={process.env.PUBLIC_URL + "/input"}
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <InputView />
            </ProtectedRoute>
          }
        />
        <Route
          path={process.env.PUBLIC_URL + "/login"}
          element={
            <LogIn
              handleLogin={handleLogin}
              isAuthenticated={isAuthenticated}
            />
          }
        />
        <Route path={process.env.PUBLIC_URL + "/"} element={<CabinetView />} />
      </Routes>
    </Router>
  );
};

export default App;
